import i18n from 'i18next';

i18n
  .init({
    whitelist: ['en', 'fr', 'de'],
    fallbackLng: 'fr',
    lng: 'fr',

    // have a common namespace used around the full app
    ns: ['common'],
    defaultNS: 'common',

    interpolation: {
      escapeValue: false // not needed for react!!
    },
    debug: false
  });

export default i18n;
 